import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { gqlWorkOrderVorTypeAndStatusFollowers } from '../workOrderQueries';

const requestId = 'workOrderVorType';

export const useWorkOrderVorTypeAndStatusFollowers = (workOrderId: number, withEffect = true) => {
    const dispatch = useDispatch();

    const variables = useMemo(() => ({ workOrderId }), [workOrderId]);

    const [workOrderVorTypeDataReset] = useResetStoreData({
        requestId,
    });

    const [workOrderVorTypeData, , , workOrderVorTypeDataRequest] = useRequest({
        requestId,
        query: gqlWorkOrderVorTypeAndStatusFollowers,
        variables,
        withEffect,
    });

    const workOrderVorTypeDataMakeRequest = useCallback(() => {
        workOrderVorTypeDataReset(undefined);
        dispatch(workOrderVorTypeDataRequest(variables));
    }, [dispatch, variables, workOrderVorTypeDataRequest, workOrderVorTypeDataReset]);

    return {
        workOrderVorTypeData,
        workOrderVorTypeDataMakeRequest,
    };
};
